import {
	connect
} from 'react-redux'
import MaintenanceSearchComponent from '../components/MaintenanceSearchComponent.jsx';
import {
	findSearchEpcList,
	cleanSearchEpcAlert,
	closeSearchMRecordModal,
	cleanSearchEpclList,
	cleanSearchMRecordList,
	findSearchEpcListByReadEpc,
	forwardToShowRfidConfig,
	forwardToHideRfidConfig,
	forwardToCleanRfidChips
} from '../actions';

const mapStateToProps = (state) => ({
	roles: state.getIn(['authReducer', 'roles']),
	alertStyle: state.getIn(['searchReducer', 'alertStyle']),
	alertMessage: state.getIn(['searchReducer', 'alertMessage']),
	showModal: state.getIn(['maintenanceSearchReducer', 'showModal']),

	isLoadingChipEpcs: state.getIn(['maintenanceSearchReducer', 'isLoadingChipEpcs']),
	view: state.getIn(['checkCardReducer', 'view'])
})

const mapDispatchToProps = (dispatch) => ({
	searchEpc: (searchEpcInput) => {
		dispatch(findSearchEpcList({ searchEpcInput: searchEpcInput }));
		dispatch(cleanSearchMRecordList());
	},
	searchLabelId: (searchLabelIdInput) => {
		dispatch(findSearchEpcList({ searchLabelIdInput: searchLabelIdInput }));
		dispatch(cleanSearchMRecordList());
	},
	cleanAlert: () => {
		dispatch(cleanSearchEpcAlert());
	},
	closeModal: () => {
		dispatch(closeSearchMRecordModal());
	},
	cleanSearchResult: () => {
		dispatch(cleanSearchEpclList());
		dispatch(cleanSearchMRecordList());
	},
	readRfidChips: (speedway) => {
		dispatch(findSearchEpcListByReadEpc(speedway));
		dispatch(cleanSearchMRecordList());
	},
	showRfidConfig: () =>{
		dispatch(forwardToShowRfidConfig());
	},
	hideRfidConfig: () =>{
		dispatch(forwardToHideRfidConfig());
	},
	cleanRfidChips: () => {
		dispatch(forwardToCleanRfidChips());
	},
})

const MaintenanceSearchContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceSearchComponent)

export default MaintenanceSearchContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceSearchContainer.jsx